import React, { useEffect, useState } from 'react';
import { addProtocolToLink } from '../../../../helpers/addProtocolToLink';
import * as ProfileInterface from '../../../../interfaces/profile.interface';

const WebsiteInput: React.FunctionComponent<
  ProfileInterface.IWebsiteInputProps
> = ({ website, handleSubmit, isWebsiteEditable, setIsWebsiteEditable }) => {
  const [edited, setEdited] = useState(false);
  const [link, setLink] = useState(website.link);

  useEffect(() => {
    if (!isWebsiteEditable) setEdited(false);
  }, [isWebsiteEditable]);

  return (
    <form
      className="flex"
      onSubmit={(event) => {
        event.preventDefault();
        if (link !== website.link) {
          handleSubmit(event, website._id, {
            link: link,
            viewPermission: website.viewPermission,
            socialNetwork: 'website',
          });
        }
        setIsWebsiteEditable(false);
        setEdited(false);
      }}
    >
      <div
        className={`${
          isWebsiteEditable ? 'border border-dashed border-[#2691BD]' : ''
        } group-one relative p-2 bg-[#2691BD]/10 rounded-lg my-2`}
      >
        <div className="hidden group-one-hover:block absolute top-0 right-0 mt-[-35px] mr-[-20px] bg-[#888888]/50 text-white px-2 py-1 rounded-xl">
          <small>Đi đến trang</small>
        </div>
        <input
          maxLength={256}
          className={`${
            isWebsiteEditable ? '' : 'hidden'
          } w-full bg-transparent focus:outline-none`}
          type="text"
          onChange={(e) => {
            setLink(e.target.value);
            setEdited(true);
          }}
          value={link}
        />
        {/* hack to make input tags have the same size as the text inside */}
        <a
          href={addProtocolToLink(website.link)}
          target="_blank"
          rel="noreferrer"
        >
          <p
            className={`${
              isWebsiteEditable ? 'h-0 invisible' : ''
            } text-[#979797] whitespace-nowrap text-ellipsis overflow-hidden max-w-[30vw] hover:text-primary`}
          >
            {website.link}
          </p>
        </a>
      </div>

      <input
        className={`${
          edited ? '' : 'hidden'
        } mx-3 text-[#2691BD] cursor-pointer hover:text-[#2691BD]/70`}
        type="submit"
        value="Lưu"
      />
    </form>
  );
};

export default WebsiteInput;
